import { CardImplementationDtoToEntity } from "src/app/features/CardImplementation/services/mappers/CardImplementationDtoToEntity";
import type { CardImplementationDto } from "src/app/features/CardImplementation/types/CardImplementationDto";
import type { CardImplementationEntity } from "src/app/features/CardImplementation/types/CardImplementationEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const CardImplementationTableDtoMapper = (
    input: Readonly<ResourcePageDto<CardImplementationDto>>,
): ResourcePageEntity<CardImplementationEntity> => {
    return {
        list: input.list ? input.list.map(CardImplementationDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
